/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Sharedplan_HoldInputs */

const en_us2_sharedplan_hold = /** @type {(inputs: Sharedplan_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_br2_sharedplan_hold = /** @type {(inputs: Sharedplan_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_pt2_sharedplan_hold = /** @type {(inputs: Sharedplan_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

/** @type {(inputs: Sharedplan_HoldInputs) => LocalizedString} */
const es_419_sharedplan_hold = en_us2_sharedplan_hold;

/** @type {(inputs: Sharedplan_HoldInputs) => LocalizedString} */
const fr_fr2_sharedplan_hold = en_us2_sharedplan_hold;

/** @type {(inputs: Sharedplan_HoldInputs) => LocalizedString} */
const de_de2_sharedplan_hold = en_us2_sharedplan_hold;

/** @type {(inputs: Sharedplan_HoldInputs) => LocalizedString} */
const it_it2_sharedplan_hold = en_us2_sharedplan_hold;

/**
* | output |
* | --- |
* | "{seconds} s" |
*
* @param {Sharedplan_HoldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_hold = /** @type {((inputs: Sharedplan_HoldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_HoldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_hold(inputs)
	if (locale === "es-419") return es_419_sharedplan_hold(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_hold(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_hold(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_hold(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_hold(inputs)
	return en_us2_sharedplan_hold(inputs)
});
export { sharedplan_hold as "sharedplan.hold" }